// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ScMr","top":"styles_top__22qKQ","left":"styles_left__2BEcK","description":"styles_description__1u6sL"};